import { AuthError } from "@supabase/supabase-js";

export class ApiValidationError extends Error {
  constructor(...params: any[]) {
    super(...params);
    Object.setPrototypeOf(this, ApiValidationError.prototype);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiValidationError);
    }
    this.name = "ApiValidationError";
  }
}

export class ResponseError extends Error {
  constructor(public response: Response) {
    super("Request returned a non-2xx status code");
    Object.setPrototypeOf(this, ResponseError.prototype);
    this.name = "ResponseError";
  }
}

export class NotFoundError extends Error {
  constructor(msg: string) {
    super(msg);
    Object.setPrototypeOf(this, NotFoundError.prototype);
    this.name = "NotFoundError";
  }
}

export class NotAuthenticatedError extends Error {
  constructor(msg: string) {
    super(msg);
    Object.setPrototypeOf(this, NotAuthenticatedError.prototype);
    this.name = "NotAuthenticatedError";
  }
}

export class SupabaseAuthError extends Error {
  constructor(error: AuthError) {
    super();
    Object.setPrototypeOf(this, SupabaseAuthError.prototype);
    this.name = "GoTrueApiError";
    this.message = error.message;
  }
}

export class AudioContextNotReadyError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, AudioContextNotReadyError.prototype);
    this.name = "AudioContextNotReadyError";
  }
}

export class ResendError extends Error {
  constructor(message: string, name: string) {
    super(message);
    Object.setPrototypeOf(this, ResendError.prototype);
    this.name = name;
    this.message = message;
  }
}

export class FileProcessingError extends Error {
  filename: string;
  constructor(filename: string, cause: unknown) {
    super(`Failed to process "${filename}"`);
    Object.setPrototypeOf(this, FileProcessingError.prototype);
    this.name = "FileProcessingError";
    this.filename = filename;
    this.cause = cause;
  }
}
